module.exports = __webpack_public_path__ + "static/img/yeswecan0025.899527f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/yeswecan0025.png
// module id = 591
// module chunks = 1